module.exports = __webpack_public_path__ + "img/Ciper.9c8531f5.png";